import React from 'react';

interface QuizGenerationProgressProps {
  isGenerating: boolean;
}

const QuizGenerationProgress: React.FC<QuizGenerationProgressProps> = ({ isGenerating }) => {
  if (!isGenerating) return null;

  return (
    <div className="col-12">
      <div className="card border-0 shadow-sm" style={{ borderRadius: '20px' }}>
        <div className="card-body p-5 text-center">
          <div className="mb-4">
            <div className="spinner-border text-primary" style={{ width: '4rem', height: '4rem' }} role="status">
              <span className="visually-hidden">Generating...</span>
            </div>
          </div>
          <h4 className="fw-bold text-primary mb-3">
            <i className="fas fa-magic me-2"></i>
            Generating Your Custom Quiz
          </h4>
          <p className="text-muted mb-4">
            Please wait while we create a personalized quiz based on your preferences...
          </p>
          
          {/* Progress Steps */}
          <div className="row g-3 justify-content-center">
            <div className="col-md-3">
              <div className="d-flex align-items-center justify-content-center p-3 bg-light rounded">
                <i className="fas fa-search text-primary me-2"></i>
                <small className="text-muted">Finding Questions</small>
              </div>
            </div>
            <div className="col-md-3">
              <div className="d-flex align-items-center justify-content-center p-3 bg-light rounded">
                <i className="fas fa-filter text-primary me-2"></i>
                <small className="text-muted">Applying Filters</small>
              </div>
            </div>
            <div className="col-md-3">
              <div className="d-flex align-items-center justify-content-center p-3 bg-light rounded">
                <i className="fas fa-cogs text-primary me-2"></i>
                <small className="text-muted">Building Quiz</small>
              </div>
            </div>
            <div className="col-md-3">
              <div className="d-flex align-items-center justify-content-center p-3 bg-light rounded">
                <i className="fas fa-check-circle text-success me-2"></i>
                <small className="text-muted">Almost Ready</small>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default QuizGenerationProgress;